import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeStyles = {
  sm: 'dls-h-8 dls-w-8',
  md: 'dls-h-16 dls-w-16',
  lg: 'dls-h-20 dls-w-20',
};

export function LoadingSpinner({ className, size = 'md' }: LoadingSpinnerProps) {
  return (
    <div className={cn('dls-flex dls-items-center dls-justify-center', className)}>
      <img
        src="/neeve_loader.gif"
        alt="Loading"
        className={sizeStyles[size]}
      />
    </div>
  );
}

export function PageLoader() {
  return (
    <div className="dls-flex dls-items-center dls-justify-center dls-min-h-[400px]">
      <LoadingSpinner size="lg" />
    </div>
  );
}
